export function formatLastLogin(raw: string, includeTimezone = false): string {
    if (!raw) {
        return '';
    }
    const parts = raw.split(', ');
    if (parts.length < 2) {
        return raw;
    }
    const [month, day, year] = parts[0].split('/').map(Number);
    const [hourStr, minuteAmPm] = parts[1].split(':');
    const hour = Number(hourStr);
    const timezone = includeTimezone && parts[2] ? `, ${parts[2]}` : '';
    return `${month}/${day}/${year}, ${hour}:${minuteAmPm}${timezone}`;
}
